import vue from 'vue'
// import NP from 'number-precision'
import { isNull, isNumber } from '../../assets/js/validators'
import store from '../../store/index'
// import ViewModel from '../components/viewPage.vue'
import Bus from '../../assets/js/eventBus'
// import orderViewUser from '../components/orderViewUser.vue'
// import orderViewClient from '../components/orderViewClient.vue'
import orderStatus from './../components/orderStatus.vue'
import statusSwitch from './../components/statusSwitch.vue'
const that = vue.prototype
export default {
  className: 'Order',
  mixin: {
    actionWidth: 120,
    fields: [
      { // 销售信息
        name: 'userid',
        note: '销售人员',
        width: 100,
        // view: {
        //   component: orderViewUser
        // }
      },
      {
        name: 'userCompany',
        note: '所属公司',
        width: 100,
        validators: [
          val => (val) ? null : '所属公司不可为空'
        ]
      },
      { // 型号
        name: 'finishProductid',
        listWhere: (where) => {
          where.isBatching = { $ne: true }
        },
        width: 100,
        validators: [
          isNull
        ]
      },
      {
        // 所属车间型号
        name: 'modelId',
        note: '车间型号',
        width: 100,
        render: (record) => {
          return `${record.finishProductid.model.name}`
        },
      },
      { // 吨数
        name: 'amount',
        // hidden: () => true,
        width: 80,
        validators: [
          isNull, isNumber
        ]
      },
      // {
      //   name: 'taxRate'
      // },

      { // 状态
        name: 'status',
        validators: [
          isNull
        ],
        view: {
          component: orderStatus
        },
      },
      {// 包装
        name: 'packid',
        width: 80,
      },
      {// 托盘
        name: 'palletid',
        width: 100,
      },
      {// 麦头
        name: 'markid',
      },
      { // 客户
        name: 'clientid',

        // view: {
        //   component: orderViewClient
        // },
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        listWhere: (where) => {
          // if (store.state.user.adminRole === 'sale') {
          //   where.userid = store.state.user.objectId
          // }
          if (store.state.user && store.state.user.allClient === 'Yes') { } else {
            where.userid = store.state.user.objectId
          }
        },
        validators: [
          isNull
        ],
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
      },

      { // 售价
        name: 'sellingPrice',
        disabled: true,
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        validators: [
          isNull, isNumber
        ],
        hidden: () => true
      },
      { // 成本
        name: 'costPrice',
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        disabled: true,
        validators: [
          isNull, isNumber
        ],
        hidden: () => true
      },
      { // 利润
        name: 'profit',
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        validators: [
          isNull, isNumber
        ],
        hidden: () => true
      },
      { // 运费
        name: 'shipping',
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        validators: [
          isNull, isNumber
        ],
        hidden: () => true
      },
      {// 下单日期
        name: 'orderDate',
        // hidden: () => true
      },
      { // 交付日期
        name: 'shipDate',
        validators: [
          isNull
        ]
      },
      { // 提成
        name: 'commission',
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        validators: [
          isNull, isNumber
        ],
        hidden: () => true
      },
      {
        name: 'remarks',
        width: 80,
      },

      // 更新时间
      'updatedAt'
    ]
  },
  search: [
    'userCompany',
    'modelId',
    'clientid',
  ],
  hooks: {
    async beforeSave ({ data, objectId }) {
      // if (objectId) {
      //   let order = await that.$tkParse.getData(`/classes/Order/${objectId}`).catch(e => { })
      //   let myDate = new Date(order.createdAt)
      //   if (data.status !== order.status) {
      //     let user = await that.$tkParse.getData(`/classes/_User/${order.userid}`).catch(e => { }) // 用户
      //     let Client = await that.$tkParse.getData(`/classes/Client/${order.clientid}`).catch(e => { }) // 客户
      //     let finishProduct = await that.$tkParse.getData(`/classes/finishProduct/${order.finishProductid}`).catch(e => { }) // 型号
      //     let Pack = await that.$tkParse.getData(`/classes/Pack/${order.packid}`).catch(e => { }) // 包装
      //     let Pallet = await that.$tkParse.getData(`/classes/Pallet/${order.palletid}`).catch(e => { }) // 托盘
      //     let type = {
      //       financeVerify: '未审核',
      //       add: '新订订单',
      //       read: '已读订单',
      //       madeing: '生产中订单',
      //       transit: '运输中订单',
      //       complete: '已生产完成订单',
      //       sent: '已发出订单',
      //       diliveriesTaked: '已收货订单',
      //       // confirmed: '审完成订单',
      //       finish: '已完成订单',
      //     }
      //     // TODO 发送短信消息
      //     that.$tkParse.post('/sms/send', {
      //       'phone': user.username,
      //       'templateId': 'HqLgB1',
      //       'vars': {
      //         // 短信模板变量
      //         message: `您于${myDate.getMonth() + 1}月${myDate.getDate()}日下单的${Client.name + finishProduct.name} ${Pack.name + Pallet.name} ${type[data.status]}`
      //       }
      //     })
      //   }
      // }
    },
    async beforeFetch ({ where }) {
      where.status = 'add'
      where.isReserve = { $ne: true }
      if (where.modelId) {
        if (where.modelId === 'null') {
          delete where.finishProductid
          delete where.modelId
        } else {
          let res = await that.$modelAjax.getData('finishProduct', {
            params: {
              where: {
                model: where.modelId
              }
            }
          })
          let target = []
          for (let i in res.results) {
            target.push(res.results[i].objectId)
          }
          delete where.modelId
          where.finishProductid = { $in: target }
        }
        console.log(where)
      }
      // if (store.state.user && store.state.user.adminRole && store.state.user.adminRole === 'sale') {
      //   // 销售经理
      //   where.userid = store.state.user.objectId
      // }
      // if (store.state.user && store.state.user.adminRole === 'admin') {
      //   // 超级管理员
      // }
      // if (store.state.user && store.state.user.adminRole === 'workshop') {
      //   // 车间经理
      // where.shopManagementid = {
      //   $in: store.state.user.shopManagements
      // }
      // }
      if (store.state.user && !store.state.user.authority.order.view) {
        where.objectId = '{ $exist: false }'
      }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    },
    beforeUpdate () {
      // TODO 发送短信消息
    },
    afterUpdate () {
      store.commit('setIndexUpdate', 'yes')
    }
  },
  action: {
    choiceDel: store.state.user && store.state.user.authority.order.view
      ? {
        type: 'list',
        text: '查看所有订单',
        buttonType: 'link', // 按钮的类型
        // 点击按钮回调
        callback: async ({ vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
          vm.$router.push({ path: '/order' })
        }
      } : false,
    // edit: store.state.user && store.state.user.authority.index.edit
    //   ? {
    //     type: 'row',
    //     text: '变更状态',
    //     component: 'akModelEditor',
    //     fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
    //       userid: false,
    //       userCompany: false,
    //       taxRate: false,
    //       finishProductid: false,
    //       sellingPrice: false,
    //       amount: false,
    //       packid: false,
    //       palletid: false,
    //       markid: false,
    //       clientid: false,
    //       profit: false,
    //       shipping: false,
    //       shipDate: false,
    //       costPrice: false,
    //       commission: false,
    //       orderDate: false,
    //       status: {
    //         disabled: false
    //       },
    //       remarks: false
    //     }
    //   } : false,
    edit: store.state.user && store.state.user.authority.order.edit
      ? {
        type: 'row',
        text: '变更状态',
        title: '变更状态',
        component: statusSwitch
      } : false,
    formula: store.state.user && store.state.user.authority.order.formula
      ? {
        type: 'row',
        text: '查看配方',
        callback: function ({ record }) {
          Bus.$emit('formula', record)
          Bus.$emit('indexShowModal', true)
        }
      } : false,
    delete: false,
    // deleteAll: store.state.user && store.state.user.adminRole === 'admin'
    //   ? {
    //     type: 'list',
    //     text: '删除',
    //     component: DeleteOrder
    //   }
    //   : false
  }
}
